import { Controller } from "@hotwired/stimulus";
import { optionsForElement } from "dropzone";

const packageValues = {};
let label = ['0', '10', '20', '30', '40', '50', '60', '70', '80'];

export default class extends Controller {
  static targets = [
    "slider",
    "volume",
    "actualVolume",
    "estimationDetails",
    "option",
    "length",
    "width",
    "height",
    "unitType",
    "weight",
    "volumetricWeight",
    "weightComparison"
  ];

  connect() {
    console.log("Slider");
    this.getPackages().then(() => {
      this.addMarker();
    });
    console.log('Package Values:', packageValues);
    this.toggleSlider();
    this.setupEventListeners();
  }

  setupEventListeners() {
    const lengthInput = this.lengthTarget;
    const widthInput = this.widthTarget;
    const heightInput = this.heightTarget;

    lengthInput.addEventListener('input', () => {
      this.toggleSlider();
    });

    widthInput.addEventListener('input', () => {
      this.toggleSlider();
    });

    heightInput.addEventListener('input', () => {
      this.toggleSlider();
    });
  }

  toggleSlider() {
    const sliderInput = this.sliderTarget;
    const lengthValue = this.lengthTarget.value.trim();
    const widthValue = this.widthTarget.value.trim();
    const heightValue = this.heightTarget.value.trim();

    console.log(`Length: ${lengthValue}, Width: ${widthValue}, Height: ${heightValue}`);

    if (sliderInput) {
      if (lengthValue || widthValue || heightValue) {
        console.log('Disabling slider');
        sliderInput.disabled = true;
      } else {
        console.log('Enabling slider');
        sliderInput.disabled = false;
      }
    }
  }

  addMarker() {
    const sortedValues = packageValues.sorted || [];

    const nameToInitials = {
      "LetterSize": "LS",
      "ExtraSmall": "ES",
      "Small": "S",
      "Medium": "M",
      "Large": "L",
      "ExtraLarge": "XL",
      "ExtraExtraLarge": "XXL",
      "VeryLarge(XXXL)": "XXXL",
      "SuperLarge(XXXXL)": "XXXXL"
    };

    const lastObject = sortedValues.length - 1;
    const highestValue = sortedValues[lastObject].volume;
    console.log('highest value', highestValue)
    const optionDataList = this.optionTarget;
    const packageValuesLength = sortedValues.length;

    sortedValues.forEach((value, index) => {
      if (index < packageValuesLength) {
        while (this.optionTarget.childElementCount == sortedValues.length) {
          this.optionTarget.removeChild(this.optionTarget.firstChild);
        }

        const optionElement = document.createElement('option');
        optionElement.value = label[index];
        optionElement.label = nameToInitials[value.name] || value.name;
        optionDataList.appendChild(optionElement);
      }
    });
  }

  moveSlider() {
    const volume = this.actualVolumeTarget.value;
    const nearestValue = this.findNearestValue(volume);

    this.sliderChange(nearestValue);
    this.volumeTarget.value = nearestValue;
    // this.addVolumeDetails(nearestValue);
  }

  handleSliderChange() {
    const sortedPackages = packageValues.sorted || [];
    const value = parseInt(this.sliderTarget.value);
    console.log('Slider Value:', value);

    let sliderIndexValue = label.indexOf(String(value));
    console.log('Slider Index:', sliderIndexValue);

    const selectedPackage = sortedPackages[sliderIndexValue];
    console.log('Selected Package:', selectedPackage);

    if (sliderIndexValue >= 0 && sliderIndexValue < sortedPackages.length) {
      this.volumeTarget.value = selectedPackage.volume;
      this.actualVolumeTarget.value = selectedPackage.volume;

      // this.addVolumeDetails(selectedPackage);
      this.updateEstimationDetails(selectedPackage);
    } else {
      console.error("Invalid slider value or package data");
    }
  }

  updateEstimationDetails(selectedPackage) {
    // Clear existing content in the estimationDetails div
    this.estimationDetailsTarget.innerHTML = '';

    // Create HTML content for the selected package details
    const detailsHTML = `
      <div class="p-3">
        <h5>Selected Package Details</h5>
        <p><strong>Name:</strong> ${selectedPackage.name}</p>
        <p><strong>Volume:</strong> ${selectedPackage.volume} m³</p>
        <p><strong>Max Volume:</strong> ${selectedPackage.max_volume} m³</p>
        <p><strong>Size Comparison:</strong> ${selectedPackage.size_comparison.join(', ')}</p>
      </div>
    `;

    // Append the details to the estimationDetails div
    this.estimationDetailsTarget.innerHTML = detailsHTML;
  }

  sliderChange(value) {
    this.optionTarget.value = value;
    const optionValues = this.optionTarget.children;

    optionValues.forEach((option) => {
      if (parseFloat(option.label) === value) {
        const nearestValue = option.value;
        const inputEvent = new Event('input', { bubbles: true });
        this.sliderTarget.value = nearestValue;
        this.sliderTarget.dispatchEvent(inputEvent);
      }
    })
    this.compareWeights();
  }

  compareWeights() {
    const volumetricWeight = parseFloat(this.volumetricWeightTarget.value);
    const actualWeight = parseFloat(this.weightTarget.value);
    const compareWeight = document.getElementById("compareWeights");

    if (!isNaN(volumetricWeight) && !isNaN(actualWeight)) {
      if (volumetricWeight > actualWeight) {
        compareWeight.innerHTML = 'Use volumetric weight for packaging'
      } else if (volumetricWeight < actualWeight) {
        compareWeight.innerHTML = 'Use product dead weight for packaging'
      } else {
        console.log('Both weights are equal');
      }
    } else if (!isNaN(volumetricWeight)) {
      compareWeight.innerHTML = 'Only volumetric weight present, use this for packaging';
    } else if (!isNaN(actualWeight)) {
      compareWeight.innerHTML = 'Only product dead weight present, use this for packaging';
    } else (
        console.log('neither weights is present')
    )
  }

  findNearestValue(value) {
    const packageVolumes = Object.values(packageValues).flat().map(obj => parseFloat(obj.volume));
    return packageVolumes.reduce(function(prev, curr) {
      return (Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev);
    });
  }

  calculateVolume() {
    const length = parseFloat(this.lengthTarget.value) || 1;
    const width = parseFloat(this.widthTarget.value) || 1;
    const height = parseFloat(this.heightTarget.value) || 1;
    let volume = 1;

    const unitType = this.unitTypeTarget.value;
    console.log('unitType', unitType);

    switch (unitType) {
      case "Centimeters":
        volume = (length / 100) * (width / 100) * (height / 100);
        break;
      case "Millimeters":
        volume = (length / 1000) * (width / 1000) * (height / 1000);
        break;
      default:
        volume = length * width * height;
    }

    volume = Math.abs(volume) % 1 !== 0 ? volume.toFixed(6) : volume;

    this.volumeTarget.value = volume;
    this.actualVolumeTarget.value = volume;
    // this.calculateVolumetricWeight(volume);
  }

  clearDimensions() {
    // Reset the length, width, height, and volume fields
    this.lengthTarget.value = '';
    this.widthTarget.value = '';
    this.heightTarget.value = '';
    this.actualVolumeTarget.value = '';
    this.volumeTarget.value = '';
  
    // Clear any estimation details
    if (this.estimationDetailsTarget) {
      this.estimationDetailsTarget.innerHTML = '';
    }
  
    console.log('Dimensions cleared');
  }

  // calculateVolumetricWeight(value) {
  //   const volumetric_weight = value * 166.7;
  //   const cbm_weight = Math.abs(volumetric_weight) % 1 !== 0 ? volumetric_weight.toFixed(4) : volumetric_weight

  //   this.volumetricWeightTarget.value = cbm_weight;
  // }

  getPackages() {
    return new Promise((resolve, reject) => {
      Rails.ajax({
        type: "GET",
        url: `/packages`,
        success: (data, status, xhr) => {
          Object.keys(data).forEach((key) => {
            packageValues[key] = data[key];
          });

          // Flatten and sort the package values by volume in ascending order
          packageValues.sorted = Object.values(packageValues)
            .flat()
            .sort((a, b) => parseFloat(a.volume) - parseFloat(b.volume));

          console.log("Sorted Package Values:", packageValues.sorted);
          resolve();
        },
        error: (xhr, status, error) => {
          reject(error);
        }
      });
    });
  }
}
